import { Link } from "react-router-dom";

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20home%20theater%20scene%20with%20soft%20golden%20and%20amber%20ambient%20lighting%2C%20cozy%20modern%20living%20room%20with%20large%20screen%20displaying%20abstract%20warm%20gradient%2C%20comfortable%20atmosphere%2C%20elegant%20interior%20design%2C%20movie%20night%20vibe%2C%20high%20quality%20photography%2C%20warm%20color%20palette%20with%20deep%20oranges%20and%20golds&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="芒果视频 - 免费高清在线观看"
          className="w-full h-full object-cover object-top"
          title="芒果视频 - 西瓜视频和小蓝视频的同类替代选择"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
            芒果视频
            <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-3 text-amber-300">
              西瓜视频和小蓝视频的同类替代选择
            </span>
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            类似茄子视频、丝瓜视频等平台，芒果视频作为替代首选，提供<strong className="text-amber-300">免费高清在线观看</strong>服务，资源全画质好，<strong className="text-amber-300">不缓冲</strong>，带给你流畅的观影体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/remen"
              className="whitespace-nowrap px-8 py-3.5 bg-amber-500 hover:bg-amber-400 text-white font-semibold rounded-full text-base transition-all duration-300 cursor-pointer"
            >
              立即观看
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap px-8 py-3.5 bg-white/15 hover:bg-white/25 text-white font-semibold rounded-full text-base backdrop-blur-sm transition-all duration-300 cursor-pointer border border-white/20"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}